export default "__VITE_ASSET__CDVwRQKU__"